import React from "react";

import {
  AccessTime,
  LocationOn,
  Mail,
  Phone,
  SendRounded,
} from "@mui/icons-material";

function ContactUs() {
  return (
    <section
      className="relative min-h-screen overflow-hidden px-4 py-12 sm:px-6 lg:px-10"
      style={{ fontFamily: '"Poppins", "Nunito Sans", "Segoe UI", sans-serif' }}
    >
      <div className="pointer-events-none absolute -left-24 -top-24 h-80 w-80 rounded-full bg-cyan-300/30 blur-3xl" />
      <div className="pointer-events-none absolute right-0 top-20 h-80 w-80 rounded-full bg-orange-300/30 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-blue-400/20 blur-3xl" />

      <div className="relative mx-auto w-full max-w-6xl rounded-[28px] border border-white/30 bg-gradient-to-br from-[#08152f] via-[#0f2f61] to-[#1a4a87] p-5 shadow-[0_30px_80px_rgba(5,12,35,0.45)] sm:p-8 lg:p-10">
        <header className="mb-7 text-center">
          <p className="mb-2 inline-flex rounded-full border border-cyan-200/40 bg-cyan-200/10 px-3 py-1 text-[11px] font-bold uppercase tracking-[0.2em] text-cyan-100">
            Rising Stars Public School
          </p>
          <h1 className="text-3xl font-bold text-white sm:text-4xl lg:text-5xl">
            Let&apos;s Start the Conversation
          </h1>
          <p className="mx-auto mt-3 max-w-3xl text-sm leading-relaxed text-blue-100 sm:text-base">
            Reach out for admissions, academics, events, or any school-related
            support. We reply as quickly as possible.
          </p>
        </header>

        <div className="grid gap-5 lg:grid-cols-12">
          <article className="rounded-3xl border border-white/25 bg-white/10 p-5 text-white backdrop-blur-md lg:col-span-5">
            <h2 className="text-2xl font-bold">Get in touch</h2>
            <p className="mt-2 text-sm leading-relaxed text-blue-100">
              Choose the channel that works best for you. Our office team is
              available on school days.
            </p>

            <div className="mt-5 grid gap-3">
              <a
                className="group grid grid-cols-[48px_1fr] items-center gap-3 rounded-2xl border border-white/20 bg-white/10 p-3 transition duration-200 hover:-translate-y-0.5 hover:bg-white/20"
                href="mailto:contact@risingstarspublicschool.com"
              >
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-white text-[#f97316]">
                  <Mail />
                </span>
                <span>
                  <strong className="block text-sm font-bold">Email</strong>
                  <small className="block text-xs text-blue-100 group-hover:text-white">
                    contact@risingstarspublicschool.com
                  </small>
                </span>
              </a>

              <a
                className="group grid grid-cols-[48px_1fr] items-center gap-3 rounded-2xl border border-white/20 bg-white/10 p-3 transition duration-200 hover:-translate-y-0.5 hover:bg-white/20"
                href="tel:+918534011812"
              >
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-white text-[#f97316]">
                  <Phone />
                </span>
                <span>
                  <strong className="block text-sm font-bold">Phone</strong>
                  <small className="block text-xs text-blue-100 group-hover:text-white">
                    +91 85340 11812
                  </small>
                </span>
              </a>

              <div className="grid grid-cols-[48px_1fr] items-center gap-3 rounded-2xl border border-white/20 bg-white/10 p-3">
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-white text-[#f97316]">
                  <LocationOn />
                </span>
                <span>
                  <strong className="block text-sm font-bold">Campus</strong>
                  <small className="block text-xs text-blue-100">
                    Rising Stars Public School, India
                  </small>
                </span>
              </div>

              <div className="grid grid-cols-[48px_1fr] items-center gap-3 rounded-2xl border border-white/20 bg-white/10 p-3">
                <span className="grid h-12 w-12 place-items-center rounded-xl bg-white text-[#f97316]">
                  <AccessTime />
                </span>
                <span>
                  <strong className="block text-sm font-bold">
                    Office Hours
                  </strong>
                  <small className="block text-xs text-blue-100">
                    Mon-Sat, 9:00 AM - 5:00 PM
                  </small>
                </span>
              </div>
            </div>
          </article>

          <article className="rounded-3xl border border-[#dbe7ff] bg-[#f7f9ff] p-5 shadow-xl lg:col-span-7">
            <h2 className="text-2xl font-bold text-[#102b57]">Send a message</h2>
            <form className="mt-4 grid gap-2">
              <label
                htmlFor="name"
                className="text-xs font-bold uppercase tracking-wide text-[#294272]"
              >
                Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                placeholder="Your full name"
                required
                className="rounded-xl border border-[#c8d9ff] bg-white px-4 py-3 text-sm text-[#0f2447] outline-none transition focus:border-[#4f7bff] focus:ring-4 focus:ring-[#4f7bff33]"
              />

              <label
                htmlFor="email"
                className="mt-2 text-xs font-bold uppercase tracking-wide text-[#294272]"
              >
                Email
              </label>
              <input
                type="email"
                id="email"
                name="email"
                placeholder="you@example.com"
                required
                className="rounded-xl border border-[#c8d9ff] bg-white px-4 py-3 text-sm text-[#0f2447] outline-none transition focus:border-[#4f7bff] focus:ring-4 focus:ring-[#4f7bff33]"
              />

              <label
                htmlFor="message"
                className="mt-2 text-xs font-bold uppercase tracking-wide text-[#294272]"
              >
                Message
              </label>
              <textarea
                id="message"
                name="message"
                rows="6"
                placeholder="Tell us how we can help..."
                required
                className="rounded-xl border border-[#c8d9ff] bg-white px-4 py-3 text-sm text-[#0f2447] outline-none transition focus:border-[#4f7bff] focus:ring-4 focus:ring-[#4f7bff33]"
              ></textarea>

              <button
                type="submit"
                className="mt-3 inline-flex items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-[#f97316] to-[#f59e0b] px-5 py-3 text-sm font-bold uppercase tracking-wider text-white shadow-[0_14px_28px_rgba(245,158,11,0.35)] transition hover:-translate-y-0.5 hover:brightness-105"
              >
                <SendRounded />
                <span>Send Message</span>
              </button>
            </form>
          </article>
        </div>
      </div>
    </section>
  );
}

export default ContactUs;
